// **====== Leaderboard Main Services ======** //
import { extractNumericChanges }                                    from '../helpers/normalize.js'
import { resolveBarLayoutValues }                                   from '../helpers/enrich.js'
import { mapActiveToPriceDataKeyDictionary,
         projectToBarLayoutSchema }                                 from '../helpers/projection.js'
import { formatNumberTwoDecimal, formatPercent, formatDollar }      from '../../../utilities/formatNumber.js';

export const assembleCPDActiveKeys = (period, type) => {
    console.log("[ENTERING 'ACTIVE' CPD KEYS MAIN ASSEMBLY SERVICE]")
    console.log(`${"=".repeat(30)}`) 
    console.log("[ACTIVE PERIOD]: ", period)
    console.log("[ACTIVE TYPE]:   ", type)
    console.log(`${"=".repeat(30)}`)      
    // Assembly Ochestrator: Orchestrating NEP Technique 
    
    // Step 1 Normalize / Parse: N/A

    // Step 2 Enrich: N/A

    // Step 3 Projection
    return mapActiveToPriceDataKeyDictionary(period, type)
}

export const resolveStackedClassForColor = (heat, flag) => {
    console.log("[ENTERING 'ACTIVE' HEAT KEY STACKED CLASS RESOLUTION]: ", flag)
    console.log(`${"=".repeat(30)}`)
    //  Resolution Ochestrator: Orchestrating NEP Technique 
    
    // S0 Eval
    if (heat === "N/A") {
        console.log("[HEAT KEY VALUE]:          ", heat)
        console.log("[STACKED CLASS FOR COLOR]: ", "heat-neutral")
        console.log(`${"=".repeat(30)}`)          
        return "heat-neutral"
    }
    
    // Step 1 Normalize / Parse

    // Step 2 Enrich

    // Step 3 Projection
    const dictionary = {
        true:  "heat-up",
        false: "heat-down", 
    }

    return dictionary[heat]
 
}

export const resolveStackedClassForColorShading = (shading, flag) => {
    console.log("[ENTERING 'ACTIVE' HEAT COLOR SHADING KEY STACKED CLASS RESOLUTION]: ", flag)
    console.log(`${"=".repeat(30)}`)
    //  Resolution Orchestrator: Orchestrating NEP Technique

    // S0 Eval: IPO window (N/A) cells get no shade - heat-neutral already paints them grey
    if (!shading) {           // bring back shading === "N/A" once integrated on backend
        console.log("[SHADING KEY VALUE]:     ", shading)
        console.log("[STACKED CLASS FOR SHADE INTENSITY OF COLOR]: ", "omitted")
        console.log(`${"=".repeat(30)}`)
        return ""
    }
    
    // Step 1 Normalize / Parse

    // Step 2 Enrich: temporary bridge until we hydrate the object with the oneDayShading props for this to consume


    // Step 3 Projection
    const dictionary = {
        1: "heat-tier-1",
        2: "heat-tier-2",
        3: "heat-tier-3" 
    }

    return dictionary[shading]
}

export const resolveChangeSignage = (change, heat, type) => {
    //S0 Eval
    if (change === "N/A") {
        console.log("[CHANGE KEY VALUE]:       ", change)
        console.log("[CHANGE VALUE RETURNED]:  ", "Period in IPO Window")
        console.log(`${"=".repeat(30)}`)           
        return 'Period in IPO Window'
    }
    // Step 1 Normalize / Parse

    // Step 2 Enrich

    // Step 3 Projection

    if (heat === true  && type === 'percent') return `+${formatPercent(formatNumberTwoDecimal(change))}`
    if (heat === false && type === 'percent') return `${formatPercent(formatNumberTwoDecimal(change))}`
    if (heat === true  && type === 'nominal') return `+${formatDollar(formatNumberTwoDecimal(change))}`
    if (heat === false && type === 'nominal') return `${formatDollar(formatNumberTwoDecimal(change))}`

    /*
    {
        id:                    678,
        name:                  "Cerebras Systems",
        oneDayHeat:            true,
        oneDayNominalChange:   3.9199999999999875,
        oneDayPercentChange:   1.8801861000527609,
        oneMonthHeat:          true,
        oneMonthNominalChange: 16.28,
        oneMonthPercentChange: 8.300616937745374,
        oneYearHeat:           "N/A",
        oneYearNominalChange:  "N/A",
        oneYearPercentChange:  "N/A",
        priceCurrent:          212.41,
        priceT1:               208.49,
        priceT30:              196.13,
        priceT365:             "N/A",
        ticker:                "CBRS"
    }
    */

}

export const assembleBarLayoutDTO = (orderedCompanyPriceData, cpdActiveFields) => {
    console.log("[ENTERING BAR LAYOUT DTO MAIN ASSEMBLY SERVICE]")
    console.log(`${"=".repeat(30)}`)
    console.log("[ACTIVE CHANGE FIELD]: ", cpdActiveFields.change)
    console.log(`${"=".repeat(30)}`)
    // Assembly Orchestrator: Orchestrating NEP Technique

    // S0 Eval: N/A - IPO window rows don't fork anything: Step 1 leaves them off the scale, Step 2 gives them an empty bar

    // Step 1 Normalize / Parse: the changes that can sit on a numeric axis
    const numericChanges  = extractNumericChanges(orderedCompanyPriceData, cpdActiveFields)

    // Step 2 Enrich: each bar's left / width on the one shared scale, 0 at the middle of the track + the track's gutters
    const barLayoutValues = resolveBarLayoutValues(orderedCompanyPriceData, cpdActiveFields, numericChanges)

    // Step 3 Projection
    return projectToBarLayoutSchema(barLayoutValues)
}